// Realitní kancelář – parametry na detailu ([data-ro-params], markup detail/params.php, návrh ř. 362–372).
// Bez JS je vidět celá tabulka. JS schová řádky za prvními šesti (<tbody data-ro-params-more>) a ukáže
// tlačítko, které je přepíná; popisky z kolonek (data-label-more / data-label-less).

export default function initRoParamsToggle() {
  document.querySelectorAll('[data-ro-params]').forEach((box) => {
    const more = box.querySelector('[data-ro-params-more]');
    const button = box.querySelector('[data-ro-params-toggle]');
    if (!more || !button) {
      return;
    }
    const set = (open) => {
      more.hidden = !open;
      button.setAttribute('aria-expanded', String(open));
      button.textContent = open ? button.dataset.labelLess : button.dataset.labelMore;
    };
    set(false);
    button.hidden = false;
    button.addEventListener('click', () => set(more.hidden));
  });
}
